@if (!isViewer) {
<faxe-toolbar>
  <ng-container left>
    <mat-icon color="primary" svgIcon="menu" (click)="menuClick(drawer)">
    </mat-icon>
  </ng-container>
  <ng-container center>
    <h1 class="race-class" (click)="raceClassClick()">
      {{ (selectedRace$ | async)?.raceName }}
    </h1>
  </ng-container>
  <ng-container right>
    @if (showAndonMenu) {
    <mat-icon color="primary" svgIcon="widgets" (click)="rightDrawer.toggle()">
    </mat-icon>
    } @if ( showClock ) {
    <span class="clock"
      ><b> {{ time | date: 'HH:mm:ss' }}</b></span
    >
    }
  </ng-container>
</faxe-toolbar>
}
<div class="progress-bar">
  @if (dialogClosed$ | async) {
  <div>
    @if (loading$ | async) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </div>
  }
</div>
<div class="notification-wrapper">
  <faxe-notification-area (renderHeight)="onHeight($event)">
  </faxe-notification-area>
</div>
<mat-sidenav-container class="example-container">
  <div class="right" (click)="drawer.opened ? drawer.toggle() : undefined">
    <div
      id="page-content"
      [ngClass]="{
        'content-page-wrapper-no-toolbar': isViewer,
        'content-page-wrapper': true,
        'one-column': !this.numOfCols || this.numOfCols <= 1,
        'two-columns': this.numOfCols === 2,
        'three-columns': this.numOfCols === 3
      }"
    >
      <!-- FAB button -->
      <!--  <div id='andon' class="example-flex-container">
      <div class="example-button-container">
        <button mat-fab aria-label="Example icon button with a delete icon">
          <mat-icon svgIcon="menue"></mat-icon>
        </button>
      </div>
    </div>-->
      <ng-content></ng-content>
    </div>
    <router-outlet name="dialog"></router-outlet>
    <faxe-snack-bar></faxe-snack-bar>

    <faxe-toolbar id="footer">
      <ng-container left>
        <ng-content select="[left_footer]"></ng-content>
      </ng-container>
      <ng-container center>
        <ng-content select="[center_footer]"></ng-content>
      </ng-container>
      <ng-container right>
        <ng-content select="[right_footer]"></ng-content>
      </ng-container>
    </faxe-toolbar>
  </div>
  <mat-sidenav #drawer class="example-sidenav" mode="side" position="start">
    <Span class="faxe-header">Eventing</Span>
    <mat-list>
      <mat-divider></mat-divider>
      @for (item of leftMenuItems; track item) {
      <mat-list-item matRipple (click)="menuItemClick(item, drawer)">
        <mat-icon matListItemIcon [svgIcon]="item.iconName"></mat-icon>
        <div matListItemTitle>{{ item.displayname }}</div>
        @if (item.description) {
        <div matListItemLine>{{ item.description }}</div>
        }
      </mat-list-item>
      }
    </mat-list>

    <div class="footer">
      <div class="footer-content">
        <p class="app-txt" style="font-size: x-small; text-align: center">
          E S T . 2 0 2 2
        </p>
        <p class="app-txt" style="font-size: x-large; text-align: center">
          RAG
        </p>
        <p class="app-txt" style="font-size: x-small; text-align: center">
          - E V E N T I N G - S O L U T I O N S -
        </p>
      </div>
    </div>
  </mat-sidenav>
  <!-- Right Drawer -->
  <mat-sidenav #rightDrawer class="example-sidenav" mode="side" position="end">
    <Span class="faxe-header">Hjälpfunktioner</Span>
    <mat-list>
      @if (menuItemsSupport?.length) {
      <div mat-subheader>Support</div>
      }
      <mat-divider></mat-divider>
      @for (item of menuItemsSupport; track item) {
      <mat-list-item matRipple (click)="menuItemClick(item, drawer)">
        <mat-icon matListItemIcon [svgIcon]="item.iconName"></mat-icon>
        <div matListItemTitle>{{ item.displayname }}</div>
        @if (item.description) {
        <div matListItemLine>{{ item.description }}</div>
        }
      </mat-list-item>
      } @if (menuItemsRace?.length) {
      <div mat-subheader>Tävling</div>
      }
      <mat-divider></mat-divider>
      @for (raceItem of menuItemsRace; track menuItemsRace) {
      <mat-list-item matRipple (click)="menuItemClick(raceItem, drawer)">
        <mat-icon matListItemIcon [svgIcon]="raceItem.iconName"></mat-icon>
        <div matListItemTitle>{{ raceItem.displayname }}</div>
        @if (raceItem.description) {
        <div matListItemLine>{{ raceItem.description }}</div>
        }
      </mat-list-item>
      }
    </mat-list>
  </mat-sidenav>
</mat-sidenav-container>
